import { router } from "@inertiajs/react";
import { LoaderIcon, RefreshCw, TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

export function Loading() {
	const { t } = useTranslation("bonus-ro");

	return (
		<output className="flex items-center justify-center gap-2 py-12 text-sm text-muted-foreground">
			<LoaderIcon className="size-4 animate-spin" />
			{t("loading")}
		</output>
	);
}

/** A failed backend read with a retry that reloads only the prop that failed. */
export function LoadFailed({
	title,
	error,
	only,
}: {
	title: string;
	error: string;
	only: string;
}) {
	const { t } = useTranslation("bonus-ro");

	return (
		<Alert variant="destructive">
			<TriangleAlert className="size-4" />
			<AlertTitle>{title}</AlertTitle>
			<AlertDescription className="flex flex-col items-start gap-3">
				<span>{error}</span>
				<Button
					variant="outline"
					size="sm"
					onClick={() => router.reload({ only: [only] })}
				>
					<RefreshCw className="size-4" />
					{t("failed.retry")}
				</Button>
			</AlertDescription>
		</Alert>
	);
}
